<template>
  <OwnStack
    class="dialog-heading"
    align="center"
    justify="between"
    spacing="6"
    row
  >
    <OwnStack align="center" spacing="3" row>
      <slot name="icon-left"></slot>
      <OwnType v-if="title" :text="title" variant="title" />
    </OwnStack>
    <OwnButton @click="$emit('cancel')">
      <template #icon-left>
        <PhX size="24" />
      </template>
    </OwnButton>
  </OwnStack>
</template>

<script>
import { PhX } from 'phosphor-vue/dist/phosphor-vue.esm'

import { OwnButton, OwnStack, OwnType } from '@/ui'

export default {
  name: 'DialogHeading',
  components: {
    OwnButton,
    OwnStack,
    OwnType,
    PhX,
  },
  props: {
    title: { type: String, default: undefined },
  },
}
</script>

<style lang="scss" scoped>
.dialog-heading {
  border-bottom: 1px dashed $background-divider;
  padding: 24px;
}
</style>
